import React from 'react';
import QuickLinks from './QuickLinks';
import styles from './Offers.css.js';
import Radium from 'radium';
import blue from '@bit/bluekeel.assets.usc_full_logo';

const Offers = ({ tracking }) => (
    <div style={{...styles.main, ...styles[tracking.theme]}}>
        <div style={styles.brandContainer}>
            <img 
                src={blue} 
                alt='bluekeel_brand' 
                style={styles.brand}
            />
        </div>         
        <QuickLinks tracking={tracking} />
        <div style={styles.optional}>
            <b>Responding to these partner offers is completely optional.</b>
            {/* If you choose to respond, you may be contacted by our select partners via email, phone (if applicable) or mail to receive some exciting offers. */}
        </div>
        <div style={styles.purchase}>
            <b>NO PURCHASE OR FEE NECESSARY TO ENTER. 
                A PURCHASE WON'T IMPROVE AN INDIVIDUAL'S CHANCE OF WINNING.
                Please note that these offers are not made by or on behalf of pch.com</b>
        </div>
        <div style={styles.purchase}>
        Be sure to return to <a alt='pch home' href='https://www.pch.com' target='_blank' rel='noreferrer'>pch.com</a> to complete the processing of your entry.
        </div>
        <div style={styles.copy}>&copy; pch.com. All Rights Reserved.</div>
    </div>
);

export default Radium(Offers);